/**
 * features/setup/teacherHrWrite.ts
 * ------------------------------------------------------------------
 * Create a teacher's HR staff record from Setup → Teachers (lib/teacherHr
 * decides what goes in it). One write to hrStaff at tch-<teacherId> — a
 * create, refused by firestore.rules if the record already exists or
 * carries anything beyond the teacher's own details — and one hrAuditLog
 * entry, so HR can see who added the person and from where.
 * ------------------------------------------------------------------ */
import { collection, doc, getDoc } from 'firebase/firestore';
import { addDoc, db, setDoc } from '@/lib/firebase';
import { hrRecordForTeacher, type StaffLike, type TeacherLike } from '@/lib/teacherHr';

export async function createTeacherHrRecord(
  teacher: TeacherLike,
  staff: StaffLike[],
  actor: { uid?: string; email?: string | null },
): Promise<string> {
  const { id, data } = hrRecordForTeacher(teacher, staff, actor.uid ?? 'unknown');
  const ref = doc(db, 'hrStaff', id);
  if ((await getDoc(ref)).exists()) throw new Error(`${teacher.lastName} already has an HR record.`);
  await setDoc(ref, data);
  await addDoc(collection(db, 'hrAuditLog'), {
    action: 'staff.create', actorId: actor.uid ?? 'unknown', actorEmail: actor.email ?? undefined, subjectId: id,
    after: { employeeNo: data.employeeNo, name: `${data.firstName} ${data.lastName}`, category: 'teaching', jobTitle: data.jobTitle, linkedTeacherId: teacher.id, source: 'teacher-setup' },
    at: new Date().toISOString(),
  });
  return data.employeeNo;
}
